import { render, staticRenderFns } from "./Articlepic.vue?vue&type=template&id=42e652f1&"
import script from "./Articlepic.vue?vue&type=script&lang=js&"
export * from "./Articlepic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports